export default __webpack_public_path__ + "static/6839-6fc634fef2296929f2a5b677f906a089.jpg";